import { gql } from "@apollo/client";

const GET_BILLING_ADDRESS = gql`
  query GetBillingAddress {
    me {
      billingAddressLine1
      billingAddressLine2
      billingCity
      billingState
      billingCountry
      billingZipCode
    }
  }
`;

export default GET_BILLING_ADDRESS;
